import { z } from "zod/v4";

export const SubscriptionIntervalList = ["monthly", "annual"] as const;
export type SubscriptionInterval = (typeof SubscriptionIntervalList)[number];

export const StripeIntervalList = ["day", "month", "week", "year"] as const;
export type StripeInterval = (typeof StripeIntervalList)[number];
export const AvailableSubscriptionDiscountTypeList = [
  "percentage",
  "dollar",
] as const;
export type AvailableSubscriptionDiscountType =
  (typeof AvailableSubscriptionDiscountTypeList)[number];

export const SubscriptionVersionList = [
  "2023-01",
  "2023-07",
  "2024-02",
] as const;
export type SubscriptionVersionType = (typeof SubscriptionVersionList)[number];

export const SubscriptionDtoSchema = z.object({
  id: z.uuid(),
  isCurrent: z.boolean().default(false), // FE ONLY
  isDefault: z.boolean(),
  name: z.string(),
  version: z.enum(SubscriptionVersionList),
  defaultPrice: z.number(),
  defaultComparePrice: z.number().nullish(),
  bundlePrice: z.number().optional(),
  defaultInterval: z.enum(SubscriptionIntervalList),
  title: z.string(),
  description: z.string(),
  altHeader: z.string().nullish(),
  webUiScopes: z.any().nullish(), // TODO - typing?
  isActive: z.boolean(),
  stripeProductId: z.string().nullish(),
  stripePriceId: z.string().nullish(),
  orders: z.number().nullish(),
});

export type SubscriptionDto = z.infer<typeof SubscriptionDtoSchema>;

export const SubscriptionWithScopesDtoSchema = SubscriptionDtoSchema.extend({
  scopes: z.any().nullish(),
});
export type SubscriptionWithScopesDto = z.infer<
  typeof SubscriptionWithScopesDtoSchema
>;

export const SubscriptionWithoutWebUiScopesDtoSchema =
  SubscriptionDtoSchema.omit({
    webUiScopes: true,
  });
export type SubscriptionWithoutWithScopesDto = z.infer<
  typeof SubscriptionWithoutWebUiScopesDtoSchema
>;

export const SubscriptionBillingProviderList = ["stripe", "shopify"] as const;
export type SubscriptionBillingProvider =
  (typeof SubscriptionBillingProviderList)[number];

export const SubscriptionProrationBehaviorList = [
  "always_invoice",
  "create_prorations",
  "none",
] as const;
export type SubscriptionProrationBehavior =
  (typeof SubscriptionProrationBehaviorList)[number];

export const SubscriptionCollectionMethodList = [
  "chargeAutomatically",
  "sendInvoice",
] as const;
export type SubscriptionCollectionMethod =
  (typeof SubscriptionCollectionMethodList)[number];

export const GenericBillingPlanDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  status: z.string(),
  provider: z.enum(SubscriptionBillingProviderList),
});

export type GenericBillingPlanDto = z.infer<typeof GenericBillingPlanDtoSchema>;

const _PauseCancelReasonSchema = z.object({
  value: z.string(),
  text: z.string(),
  checked: z.boolean().optional(),
});

export const PauseCancelReasonDtoSchema = _PauseCancelReasonSchema.extend({
  items: z.array(_PauseCancelReasonSchema),
});

export type PauseCancelReasonDto = z.infer<typeof PauseCancelReasonDtoSchema>;
